import { render } from "./OfferFilters.vue?vue&type=template&id=441f0574"
import script from "./OfferFilters.vue?vue&type=script&lang=js"
export * from "./OfferFilters.vue?vue&type=script&lang=js"
script.render = render

export default script